import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, makeStyles } from '@material-ui/core';
import { useTimezone } from 'src/features/timezone/hooks/useTimezone';
import { ZoneChoice, ZoneOption } from 'src/features/timezone/types/timezone.types';
import { zoneAbbreviation } from 'src/features/timezone/utils/datetime';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 190
  }
}));

const optionLabel = (option: ZoneOption): string =>
  option.choice === 'utc' ? 'UTC' : `${option.role} (${zoneAbbreviation(option.zoneId)})`;

const TimezoneSelector: FC = () => {
  const classes = useStyles();
  const { choice, options, setChoice } = useTimezone();
  return (
    <FormControl variant="outlined" size="small" className={classes.formControl}>
      <InputLabel>Timezone</InputLabel>
      <Select
        value={choice}
        onChange={(event) => setChoice(event.target.value as ZoneChoice)}
        label="Timezone"
      >
        {options.map((option) => (
          <MenuItem key={option.choice} value={option.choice}>
            {optionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TimezoneSelector;
